<ng-template #modalContent let-modal>
  <fieldset [disabled]="args.IsReadOnly">
    <div class="modal-header align-items-end">
      <div class="d-flex" *ngIf="payroll.PayType != payTypes.Manual">
        <h4 class="modal-title me-4">
          {{ personName }}
          <span
            *ngIf="
              (payline.PaylineType == 2 ||
                payline.PaylineType == 3 ||
                payroll.PayType == payTypes.Adjustment) &&
              (payline.OverrideCheckNumber || payline.HistoryVoidData?.CheckNumber)
            "
            class="form-control d-inline py-2 px-3">
            {{
              checkNumberDisplay(
                payline.OverrideCheckNumber || payline.HistoryVoidData?.CheckNumber
              )
            }}
          </span>
          <span *ngIf="payline.PaylineType == 1">
            <input
              class="form-control d-inline mb-0"
              [(ngModel)]="payline.OverrideCheckNumber"
              placeholder="Check Number"
              style="width: 150px; height: 40px; font-size: 16px"
              (ngModelChange)="isTouched = true"
              maxlength="10"
              alphaNumeric />
          </span>
        </h4>
        <div class="me-auto" *ngIf="areTemporaryHourlyAllocationsSet">
          <button
            type="button"
            class="btn btn-icon"
            placement="right"
            ngbTooltip="Preview fields are locked, to edit totals click View/Edit Allocation below."
            tabindex="-1">
            <i class="fas fa-lock"></i>
          </button>
        </div>
        <small
          class="ms-4 my-auto"
          *ngIf="employeePay.Paylines.length > 1 && payroll.PayType != payTypes.Adjustment">
          <strong>Payline {{ getPaylineIndex(payline) }} of {{ getPaylineCount(payline) }}</strong>
        </small>
        <div class="cp-green my-auto ms-5" *ngIf="payline.PaylineType == 3">
          <em>Manual - No Check</em>
        </div>
        <div class="cp-green my-auto ms-5" *ngIf="payline.PaylineType == 2">
          <em>History Void</em>
        </div>
        <div class="cp-green my-auto ms-5" *ngIf="payline.PaylineType == 1">
          <em>No Check</em>
        </div>
      </div>
      <div *ngIf="startData && payroll.PayType == payTypes.Manual">
        <manual-payroll-header
          [payrollStartData]="startData"
          [showCancel]="false"></manual-payroll-header>
        <div class="d-flex">
          <div *ngIf="payroll.PayType == payTypes.Manual" class="mt-3">
            <span class="pe-2">{{ personName }}</span>
            <input
              class="form-control d-inline mb-0"
              [(ngModel)]="payline.OverrideCheckNumber"
              placeholder="Check Number"
              style="width: 150px; height: 40px; font-size: 16px"
              (ngModelChange)="isTouched = true"
              maxlength="10"
              alphaNumeric />
          </div>
          <div class="cp-green mt-3 align-self-center ms-auto">
            <em>Manual - No Check</em>
          </div>
        </div>
      </div>
      <!--
        TASK 20573: hide period end override for manual payrolls for now
        will implement at a later time
      -->
      <div
        [ngClass]="payroll.PayType == payTypes.Manual ? 'invisible' : ''"
        class="d-flex align-items-center">
        <small class="text-nowrap pe-2">Period End</small>
        <div class="input-group mb-0" id="period-end-override">
          <input
            class="form-control datepicker mb-0"
            [(ngModel)]="periodEndOverride"
            (ngModelChange)="onPeriodEndOverrideChange()"
            #periodCtrl="ngModel"
            [ngClass]="{ 'ng-invalid': !periodEndOverride }"
            ngbDatepicker
            #d="ngbDatepicker"
            [firstDayOfWeek]="7"
            [minDate]="minPeriodEnd"
            [maxDate]="maxPeriodEnd"
            tabIndex="-1"
            data-testid="periodEndOverride" />
          <!-- if the date was cleared, or a typed date did not fall within the valid +/- 6 week range -->
          <div
            *ngIf="
              !periodEndOverride || (periodCtrl.invalid && (periodCtrl.dirty || periodCtrl.touched))
            "
            class="input-error input-group-error">
            *invalid date
          </div>
          <img src="assets/icons/calendar.svg" (click)="d.toggle()" class="icon-append" />
        </div>
      </div>
    </div>
    <div class="modal-body pb-0">
      <!-- payline errors/warnings -->
      <div id="payline-error-container" *ngIf="payline?.Errors?.length > 0" class="row">
        <div class="col-12">
          <div class="row" *ngFor="let error of payline.Errors">
            <ng-container *ngIf="error.WarningLevel == warningLevels['Critical']">
              <div class="col-md-1 Critical-bg">Critical</div>
              <div class="col-md-11">
                {{ error.Message }}
              </div>
            </ng-container>
          </div>
          <div class="row" *ngFor="let error of payline.Errors">
            <ng-container *ngIf="error.WarningLevel == warningLevels['Warning']">
              <div class="col-2 Warning-bg">Warning</div>
              <div class="col-10">
                {{ error.Message }}
              </div>
            </ng-container>
          </div>
        </div>
      </div>

      <!-- header & clear buttons -->
      <div class="me-3 column-wrapper">
        <div class="payline-column">
          <div class="d-flex justify-content-between">
            <strong>Earnings</strong>&nbsp;
            <button
              *ngIf="showLaborAllocationButton()"
              class="btn btn-primary btn-payline-clear"
              (click)="gotoLaborAllocations()"
              tabindex="-1">
              <small>View/Edit Labor Allocations</small>
            </button>
            <button
              *ngIf="!args.IsReadOnly"
              [disabled]="paylineAllocatedByEarnings"
              class="btn btn-secondary btn-payline-clear"
              (click)="clearEarnings()"
              tabindex="-1"
              cpGTagEvent
              [params]="{ event_label: 'payroll_payline_detail_clear_earnings' }">
              <small>Clear all earnings</small>
            </button>
          </div>
        </div>
        <div class="payline-column">
          <div class="d-flex justify-content-between">
            <strong>Taxes</strong>&nbsp;
            <button
              *ngIf="!args.IsReadOnly"
              class="btn btn-secondary btn-payline-clear"
              (click)="clearTaxes()"
              tabindex="-1"
              cpGTagEvent
              [params]="{ event_label: 'payroll_payline_detail_clear_taxes' }">
              <small>Clear all withholding taxes</small>
            </button>
          </div>
          <!-- TASK 9119: pay frequency override in the tax section -->
          <div class="d-flex align-items-center">
            <label class="text-nowrap pe-1"><small>Pay Frequency</small></label>
            <select
              class="form-control text-start width-fit-content ps-2"
              [(ngModel)]="frequencyOverride"
              (ngModelChange)="onFreqOverrideChange()"
              tabindex="-1">
              <option
                *ngFor="let frequency of payrollFrequencies | enumToKeyValue"
                [value]="frequency.value">
                {{ frequency.key | camelToTitle }}
              </option>
            </select>
          </div>
        </div>
        <div [ngClass]="{ 'payline-column--large': showHoldPaymentColumn }" class="payline-column">
          <div class="d-flex justify-content-between">
            <strong>Deductions</strong>&nbsp;
            <button
              *ngIf="!args.IsReadOnly"
              class="btn btn-secondary btn-payline-clear"
              (click)="clearDeductions()"
              cpGTagEvent
              [params]="{ event_label: 'payroll_payline_detail_clear_deductions' }"
              tabindex="-1">
              <small>Clear all deductions</small>
            </button>
          </div>
        </div>
        <div *ngIf="!hideDeposits" class="payline-column">
          <div class="d-flex justify-content-between">
            <strong>Deposits</strong>&nbsp;
            <button
              *ngIf="!args.IsReadOnly"
              class="btn btn-secondary btn-payline-clear"
              (click)="clearDeposits()"
              tabindex="-1"
              cpGTagEvent
              [params]="{ event_label: 'payroll_payline_detail_clear_deposits' }">
              <small>Clear all deposits</small>
            </button>
          </div>
        </div>
      </div>

      <!-- column headers - rate/amount, hours, etc -->
      <div class="column-wrapper me-0">
        <div class="payline-column">
          <div class="row" *ngIf="payline?.Earnings?.length">
            <div class="col-3"></div>
            <div class="col-3 ellipsis-overflow"><small>Rate/Amount</small></div>
            <div class="col-3 ellipsis-overflow"><small>Hours</small></div>
            <div class="col-3 ellipsis-overflow"><small>Total</small></div>
          </div>
        </div>
        <div class="payline-column">
          <div class="row" *ngIf="payline?.Taxes?.length">
            <div class="col-2"></div>
            <div class="col-4 ellipsis-overflow"><small>Fixed/Additional</small></div>
            <div class="col-3 ellipsis-overflow"><small>Rate/Amount</small></div>
            <div class="col-3 ellipsis-overflow"><small>Total</small></div>
          </div>
        </div>
        <div [ngClass]="{ 'payline-column--large': showHoldPaymentColumn }" class="payline-column">
          <div class="row" *ngIf="payline?.Deductions?.length">
            <div [ngClass]="showHoldPaymentColumn ? 'col-2' : 'col-3'"></div>
            <div *ngIf="showHoldPaymentColumn" class="col-2 ellipsis-overflow small">
              Hold Payment
            </div>
            <div
              [ngClass]="showHoldPaymentColumn ? 'col-2' : 'col-3'"
              class="ellipsis-overflow small">
              Enter $ amount
            </div>
            <div class="col-3 ellipsis-overflow small">Rate/Amount</div>
            <div class="col-3 ellipsis-overflow small">Total</div>
          </div>
        </div>
        <div *ngIf="!hideDeposits" class="payline-column">
          <div class="row">
            <div class="col-4 ellipsis-overflow"><small>Account</small></div>
            <div class="col-4 ellipsis-overflow"><small>Deposit Rule</small></div>
            <div class="col-4 ellipsis-overflow"><small>Deposit Amount</small></div>
          </div>
        </div>
      </div>

      <!-- scrollable form container -->
      <div id="detail-form-container" class="column-wrapper">
        <div class="payline-column">
          <ng-container *ngIf="payline && payline.Earnings && earningConfigs">
            <payline-earning-row
              *ngFor="let earning of orderedEarnings; let i = index"
              [payline]="payline"
              [earning]="earning"
              [config]="earningConfigs[earning.EarningId]"
              [rowIndex]="i"
              [lastRowIndex]="orderedEarnings.length - 1"
              (onEdit)="onEarningEdited($event)"
              [clearEarningsEvent]="clearEarningsSubject.asObservable()"
              [updateEarningsEvent]="updateEarningsSubject.asObservable()">
            </payline-earning-row>
          </ng-container>
        </div>

        <div class="payline-column">
          <ng-container *ngIf="payline && payline.Taxes && taxConfigs">
            <payline-tax-row
              *ngFor="let tax of filteredTaxes; let i = index"
              [tax]="tax"
              [config]="taxConfigs[tax.TaxCode]"
              (onEdit)="onTaxEdited($event)"
              [rowIndex]="i"
              [lastRowIndex]="filteredTaxes.length - 1"
              [clearTaxesEvent]="clearTaxesSubject.asObservable()">
            </payline-tax-row>
          </ng-container>
        </div>

        <div [ngClass]="{ 'payline-column--large': showHoldPaymentColumn }" class="payline-column">
          <ng-container *ngIf="payline && payline.Deductions && deductionConfigs">
            <payline-deduction-row
              *ngFor="let deduction of orderedDeductions; let i = index"
              [deduction]="deduction"
              [showHoldPaymentColumn]="showHoldPaymentColumn"
              [config]="deductionConfigs[deduction.DeductionCode]"
              [rowIndex]="i"
              [lastRowIndex]="orderedDeductions.length - 1"
              (onEdit)="onDeductionEdited($event)"
              [clearDeductionsEvent]="clearDeductionsSubject.asObservable()">
            </payline-deduction-row>
          </ng-container>
        </div>

        <div *ngIf="!hideDeposits" class="payline-column">
          <payline-direct-deposit-row
            *ngFor="let directDeposit of directDeposits; let i = index"
            [directDeposit]="directDeposit"
            [employeeDirectDeposit]="employeeDeposits?.[directDeposit.DirectDepositId]"
            [rowIndex]="i"
            [lastRowIndex]="directDeposits.length - 1"
            (onEdit)="onDirectDepositEdited($event)"
            [clearDepositsEvent]="clearDepositsSubject.asObservable()">
          </payline-direct-deposit-row>
        </div>
      </div>
    </div>
  </fieldset>

  <div *ngIf="payroll.PayType != payTypes.Manual" class="modal-footer flex-column">
    <!-- task 13611: hide these buttons in read only mode -->
    <div *ngIf="!args.IsReadOnly && args.OpenInModal" class="d-flex align-self-end mb-2">
      <button
        type="button"
        class="btn btn-secondary btn-xs me-2"
        cpGTagEvent
        [params]="{ event_label: 'payroll_payline_detail_restore defaults' }"
        (click)="restoreDefaults()"
        tabindex="-1">
        Restore Defaults
      </button>
      <button
        type="button"
        class="btn btn-primary btn-xs"
        cpGTagEvent
        [params]="{ event_label: 'payroll_payline_detail_preview_totals' }"
        [disabled]="disablePreview || !periodEndOverride || periodCtrl.invalid"
        (click)="getPreviewTotals()"
        tabindex="-1">
        Preview Totals
      </button>
    </div>

    <lib-payline-detail-totals
      [payline]="payline"
      [showHoldPaymentColumn]="showHoldPaymentColumn"
      [payrollType]="payroll.PayType"></lib-payline-detail-totals>

    <div *ngIf="args.OpenInModal" class="d-flex align-self-end">
      <div>
        <button
          type="button"
          class="btn btn-{{ isTouched ? 'secondary' : 'primary' }}"
          cpGTagEvent
          [params]="{ event_label: 'payroll_payline_detail_cancel' }"
          (click)="modal.dismiss()"
          tabindex="-1">
          <!-- bug 8882 if changes have been made 'Cancel', else 'Return to Grid' -->
          {{ isTouched ? 'Cancel' : 'Return to Grid' }}
        </button>
      </div>
      <!-- task 13611: hide this buttons in read only mode -->
      <div class="ms-2" *ngIf="!args.IsReadOnly">
        <button
          type="button"
          class="btn btn-primary"
          [disabled]="disableSave || periodCtrl.invalid"
          cpGTagEvent
          [params]="{ event_label: 'payroll_payline_detail_ok_to_pay' }"
          [title]="
            !periodEndOverride || periodCtrl.invalid
              ? 'Enter a valid date for the Period End'
              : saveTooltip
          "
          (click)="modal.close()"
          tabindex="-1">
          OK to Pay
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="payroll.PayType == payTypes.Manual" class="modal-footer flex-column">
    <lib-payline-detail-totals
      [payline]="payline"
      [payrollType]="payTypes.Manual"></lib-payline-detail-totals>

    <div class="d-flex align-self-end">
      <div>
        <button
          type="button"
          class="btn btn-secondary"
          cpGTagEvent
          [params]="{ event_label: 'manual_payroll_payline_detail_cancel' }"
          (click)="modal.dismiss()"
          tabindex="-1">
          {{ args.IsReadOnly ? 'Close' : 'Cancel' }}
        </button>
      </div>
      <button
        *ngIf="disableSave && !args.IsReadOnly"
        type="button"
        class="btn btn-primary btn-xs ms-2"
        cpGTagEvent
        [params]="{ event_label: 'manual_payroll_payline_detail_preview_totals' }"
        [disabled]="disablePreview"
        (click)="getPreviewTotals()"
        tabindex="-1">
        Preview Totals
      </button>
      <button
        *ngIf="!disableSave && !args.IsReadOnly"
        type="button"
        class="btn btn-primary ms-2"
        cpGTagEvent
        [params]="{ event_label: 'manual_payroll_payline_detail_ok_to_pay' }"
        [title]="
          !periodEndOverride || periodCtrl.invalid
            ? 'Enter a valid date for the Period End'
            : saveTooltip
        "
        (click)="modal.close()"
        tabindex="-1">
        Looks Good
      </button>
    </div>
  </div>
</ng-template>
<div *ngIf="!args.OpenInModal" class="payline-detail-modal">
  <ng-container *ngTemplateOutlet="modalContent"></ng-container>
</div>
